// extracted by mini-css-extract-plugin
export var option = "_4p-1";
export var optionActive = "_4p-2";
export var pill = "_4p-0";